import { render, staticRenderFns } from "./Dealers.edit.vue?vue&type=template&id=356020dc&"
import script from "./Dealers.edit.vue?vue&type=script&lang=js&"
export * from "./Dealers.edit.vue?vue&type=script&lang=js&"
import style0 from "./Dealers.edit.vue?vue&type=style&index=0&id=356020dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports